import type { RecentActivityItem, SearchResultItem } from '../../../common/ui/quick-find/types.tsx';
import {
	getJiraWorkItemKeyFromActivity,
	getJiraWorkItemKeyFromSearchResult,
} from '../../../common/ui/quick-find/utils.ts';

const MIN_QUERY_LENGTH = 2;

export const isQueryMatchingActivitykey = (
	query: string,
	item: RecentActivityItem,
): RecentActivityItem | undefined => {
	if (
		query.length >= MIN_QUERY_LENGTH &&
		query.trim().toLowerCase() === getJiraWorkItemKeyFromActivity(item)?.toLowerCase()
	) {
		return item;
	}
	return undefined;
};

export const isQueryMatchingSearchResultKey = (
	query: string,
	item: SearchResultItem,
): SearchResultItem | undefined => {
	if (
		query.length >= MIN_QUERY_LENGTH &&
		query.trim().toLowerCase() === getJiraWorkItemKeyFromSearchResult(item)?.toLowerCase()
	) {
		return item;
	}
	return undefined;
};
